import { environment } from '../environments/environment';

const API_BASE_URL = environment.apiBaseUrl;

export const AppConfig = {

    loginApi: `${API_BASE_URL}/auth/signin`,
    signupApi: `${API_BASE_URL}/auth/signup`,
    changePWDApi: `${API_BASE_URL}/auth/changePassword`,


    getIncidentByIdApi: `${API_BASE_URL}/incident/getById/`,
    getAllIncidentsApi: `${API_BASE_URL}/incident/getAll`,
    getIncidentNoApi: `${API_BASE_URL}/incident/getIncidentNo/`,
    createIncidentApi: `${API_BASE_URL}/incident/post/create`,
    updateIncidentApi: `${API_BASE_URL}/incident/post/update`,
    deleteIncidentApi: `${API_BASE_URL}/incident/post/delete`,
    getIncidentChartApi: `${API_BASE_URL}/incident/chart`,
    getAllCategoriesApi: `${API_BASE_URL}/category/customGetAll`,
    getAllOfficersApi: `${API_BASE_URL}/officer/getAll`,
    getNationalityApi: `${API_BASE_URL}/nationality/getAll`,
    searchEmployeeApi: `${API_BASE_URL}/employee/searchByEmpTicketOrName`,
    getAllEmpApi: `${API_BASE_URL}/employee/getAll`,
    getAllStaffApi: `${API_BASE_URL}/contractStaff/getAll`,
    singleFileUploadApi: `${API_BASE_URL}/file/uploadFile`,
    multiFileUploadApi: `${API_BASE_URL}/file/uploadMultipleFiles`,
    fileDownloadApi: `${API_BASE_URL}/file/downloadFile`,
    getSummaryReportApi: `${API_BASE_URL}/incident/summaryReport`,
    downloadSummaryReportApi: `${API_BASE_URL}/incident/downloadSummaryFile`,
    downloadDetailedReportApi: `${API_BASE_URL}/incident/downloadIncidentDetails`,
    createOfficerApi: `${API_BASE_URL}/officer/post/create`,
    updateOfficerApi: `${API_BASE_URL}/officer/post/update`,
    deleteOfficerApi: `${API_BASE_URL}/officer/post/delete`,
    createEmployeeApi: `${API_BASE_URL}/employee/post/create`,
    updateEmployeeApi: `${API_BASE_URL}/employee/post/update`,
    deleteEmployeeApi: `${API_BASE_URL}/employee/post/delete`,
    createStaffApi: `${API_BASE_URL}/contractStaff/post/create`,
    updateStaffApi: `${API_BASE_URL}/contractStaff/post/update`,
    deleteStaffApi: `${API_BASE_URL}/contractStaff/post/delete`,

    createLostAndFoundApi: `${API_BASE_URL}/lostandfound/post/create`,
    updateLostAndFoundApi: `${API_BASE_URL}/lostandfound/post/update`,
    getAllLostAndFoundApi:  `${API_BASE_URL}/lostandfound/getAll`,

    getAllCategoriesAdminApi: `${API_BASE_URL}/category/getAll`, 
    createCategoryAdminApi: `${API_BASE_URL}/category/post/create`,
    updateCategoryAdminApi: `${API_BASE_URL}/category/post/update`,
    deleteCategoryAdminApi: `${API_BASE_URL}/category/post/delete`,

    getAllDepartmentAdminApi: `${API_BASE_URL}/department/getAll`, 
    createDepartmentAdminApi: `${API_BASE_URL}/department/post/create`,
    updateDepartmentAdminApi: `${API_BASE_URL}/department/post/update`,
    deleteDepartmentAdminApi: `${API_BASE_URL}/department/post/delete`,

    getAllEmployerAdminApi: `${API_BASE_URL}/employer/getAll`, 
    createEmployerAdminApi: `${API_BASE_URL}/employer/post/create`,
    updateEmployerAdminApi: `${API_BASE_URL}/employer/post/update`,
    deleteEmployerAdminApi: `${API_BASE_URL}/employer/post/delete`,

    getAllNationalityAdminApi: `${API_BASE_URL}/nationality/getAll`, 
    createNationalityAdminApi: `${API_BASE_URL}/nationality/post/create`,
    updateNationalityAdminApi: `${API_BASE_URL}/nationality/post/update`,
    deleteNationalityAdminApi: `${API_BASE_URL}/nationality/post/delete`,

    getAllAreaAdminApi: `${API_BASE_URL}/area/getAll`, 
    createAreaAdminApi: `${API_BASE_URL}/area/post/create`,
    updateAreaAdminApi: `${API_BASE_URL}/area/post/update`,
    deleteAreaAdminApi: `${API_BASE_URL}/area/post/delete`,

    getAllItemAdminApi: `${API_BASE_URL}/item/getAll`, 
    createItemAdminApi: `${API_BASE_URL}/item/post/create`,
    updateItemAdminApi: `${API_BASE_URL}/item/post/update`,
    deleteItemAdminApi: `${API_BASE_URL}/item/post/delete`,

    getAllServiceAdminApi: `${API_BASE_URL}/service/getAll`, 
    createServiceAdminApi: `${API_BASE_URL}/service/post/create`,
    updateServiceAdminApi: `${API_BASE_URL}/service/post/update`,
    deleteServiceAdminApi: `${API_BASE_URL}/service/post/delete`,

    getAllInjuryAdminApi: `${API_BASE_URL}/injury/getAll`, 
    createInjuryAdminApi: `${API_BASE_URL}/injury/post/create`,
    updateInjuryAdminApi: `${API_BASE_URL}/injury/post/update`,
    deleteInjuryAdminApi: `${API_BASE_URL}/injury/post/delete`,

    getAllProgramAdminApi: `${API_BASE_URL}/program/getAll`, 
    createProgramAdminApi: `${API_BASE_URL}/program/post/create`,
    updateProgramAdminApi: `${API_BASE_URL}/program/post/update`,
    deleteProgramAdminApi: `${API_BASE_URL}/program/post/delete`,

    getAllUserAdminApi: `${API_BASE_URL}/auth/getAll`,
    updateUserAdminApi: `${API_BASE_URL}/auth/post/update`,
    deleteUserAdminApi: `${API_BASE_URL}/auth/post/delete`,

    getAllHotelsApi: `${API_BASE_URL}/hotel/getAll`,


};
